module.exports = __webpack_public_path__ + "img/4230c43.jpg";